import { fetchAuthSession, signOut } from 'aws-amplify/auth';

export const checkAuthAndRedirect = async (): Promise<boolean> => {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken;
    
    if (!token || !token.payload) {
      await signOut();
      window.location.href = '/';
      return false;
    }
    
    // Check if token is expired
    const currentTime = Math.floor(Date.now() / 1000);
    if (token.payload.exp && token.payload.exp < currentTime) {
      await signOut();
      window.location.href = '/';
      return false;
    }
    
    return true;
  } catch (error) {
    await signOut();
    window.location.href = '/';
    return false;
  }
};